module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/fiascoCover_3x.6db00dc.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/fiascoCover_3x.png
// module id = AYh7
// module chunks = 41